import React from 'react';
import { useFormContext  } from '../../components/FormContext';


const PersonalInfoSection = () => {
  const { 
    formData, 
    formErrors,
    modifiedFields,  
    setFieldValue,
    setFormErrors,
    setModifiedFields 
  } = useFormContext();
  
  const handleTextChange = (field, e) => {
    const value = e.target.value;
    setFieldValue(field, value);
    setModifiedFields(prev => new Set([...prev, field]));
    
    let error = null;
    if (value.trim() === '') {
     
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } else if (/\d/.test(value)) {

      error = `${field.charAt(0).toUpperCase() + field.slice(1)} should not contain numbers`;

    }
    
    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  
  return (
    <div className="form-section">
      <h4 className="text-lg font-medium text-gray-700 mb-3">Personal Information</h4>
      
      <div className="space-y-4">
        <div>
          <label htmlFor="business-name" className="block text-sm font-medium text-gray-700 mb-1">
            Business Name
          </label>
          <input
            type="text"
            id="business-name"
            name="businessName"
            value={formData.businessName}
            onChange={(e) => handleTextChange('businessName', e)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
          
          {formErrors.businessName && modifiedFields.has('businessName') && (
            <div className="text-sm text-red-600 mt-1">
              {formErrors.businessName}
            </div>
          )}
        </div>
        
        <div>
          <label htmlFor="first-name" className="block text-sm font-medium text-gray-700 mb-1">
            Legal First and Middle Name
          </label>
          <input
            type="text"
            id="first-name"
            name="firstName"
            value={formData.firstName}
            onChange={(e) => handleTextChange('firstName', e)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
          
          {formErrors.firstName && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('firstName') && (
            <div className="text-sm text-red-600 mt-1">
              {formErrors.firstName}
            </div>
          )}
        </div>
        
        <div>
          <label htmlFor="surname" className="block text-sm font-medium text-gray-700 mb-1">
            Legal Surname
          </label>
          <input
            type="text"
            id="surname"
            name="surname"
            value={formData.surname}
            onChange={(e) => handleTextChange('surname', e)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
          
          {formErrors.surname && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('surname') && (
            <div className="text-sm text-red-600 mt-1">
              {formErrors.surname}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoSection;